export default {
    value: null,
    error: null,
    pending: false,
};



// WEBPACK FOOTER //
// ./src/init/store/docs/state.js